module.exports = __webpack_public_path__ + "static/img/lmp_image@2x.8f1f038.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/2x/lmp_image@2x.png
// module id = HHhG
// module chunks = 1